import {
  profile as profileService,
  registerNew,
  userLogin,
  verifyAccount,
  resetPassword,
  forgotPassword,
  updateProfile as updateProfileService,
} from "services/auth";
import {
  LOG_OUT,
  LOGIN_USER,
  AUTH_START,
  AUTH_ERROR,
  AUTH_END,
  REGISTER_USER,
  RESET_PASSWORD,
  FORGOT_PASSWORD,
  GET_USER_PROFILE,
  UPDATE_USER_PROFILE,
  VERIFY_ACCOUNT_START,
  VERIFY_ACCOUNT_ERROR,
  VERIFY_ACCOUNT_SUCCESS,
} from "../actions.types";
import toast from "react-hot-toast";
import {
  setAuthToken, clearToken, getCart,
  clearCart, getLocationHistory, setDeliveryFee
} from "utils/helpers";
import { getToken } from "utils/helpers";
import { addManyCart } from "services/carts";


export const registerUser = async (values) => async (dispatch) => {
  try {
    dispatch({ type: AUTH_START });
    const res = await registerNew(values);
    dispatch({ type: REGISTER_USER });
    toast.success(res?.message);
    window.open("/login", "_self");
  } catch (err) {

    dispatch({ type: AUTH_ERROR });
    const apiError = err?.response?.data?.error;
    if (apiError && typeof apiError === "object") {
      Object.keys(apiError).forEach((key) => {
        const msg = apiError[key]?.[0];
        if (msg) toast.error(msg);
      });
    } else {
      toast.error(
        err?.response?.data?.message ??
          err?.message ??
          "Registration failed",
      );
    }
  }
};

export const loginUser = async (values) => async (dispatch) => {
  try {

    dispatch({ type: AUTH_START });
    // API expects `phone`. Keep backward-compat if UI still sends `username`.
    const payload = {
      ...values,
      phone: values?.phone ?? values?.username,
    };
    if (payload?.username != null && payload?.phone != null) delete payload.username;

    const res = await userLogin(payload);
    const token = res?.data?.accessToken ?? res?.data?.token ?? res?.accessToken ?? res?.token;
    const ok =
      res?.status === true ||
      res?.success === true ||
      String(res?.status).toLowerCase() === "success" ||
      Boolean(token);
    if (!ok) {
      throw new Error(res?.message ?? "Login failed");
    }

    setDeliveryFee(res?.data?.fee ?? res?.fee);
    if (token) setAuthToken(token);
    dispatch({ type: LOGIN_USER });
    const checkCart = getCart();
    const items = checkCart?.map((data) => ({ quantity: data?.quantity, product_id: data?.product?.id }))
    toast.success(res?.message ?? "Login successful");

    if (checkCart !== null) {
      await addManyCart({ items });
      clearCart();
    }

    const redirect = getLocationHistory();
    if (redirect !== null) {
      sessionStorage.removeItem("cway:user:redirect:location");
      window.open(redirect, "_self");
      return;
    }

    window.open("/", "_self");



  } catch (err) {
    dispatch({ type: AUTH_ERROR });
    const apiError = err?.response?.data?.error;
    const fieldMsg =
      apiError?.username?.[0] ??
      apiError?.phone?.[0] ??
      apiError?.email?.[0] ??
      apiError?.password?.[0];
    toast.error(
      fieldMsg ??
      err?.response?.data?.message ??
      err?.message ??
      "There was an error with your network connection",
    );
    if (err?.response?.data?.verified === false) {
      window.open("/verify", "_self");
    }
    // toast.error(err?.response?.data?.error?.username[0] ?? err?.response?.data?.message);
  }
};

export const userProfile = async () => async (dispatch) => {
  try {
    // Don't hit profile endpoint when logged out
    if (!getToken()) return;
    dispatch({ type: AUTH_START });
    // `profileService()` already returns `res.data` from axios
    const res = await profileService();
    const payload = res?.data ?? res;
    if (payload == null || (typeof payload === "string" && payload.length === 0)) {
      // e.g. 204 No Content
      dispatch({ type: AUTH_END });
      return;
    }
    dispatch({ type: GET_USER_PROFILE, payload });

  } catch (err) {
    const status = err?.response?.status;
    // Only force logout when token is invalid/expired
    if (status === 401 || status === 403) {
      dispatch({ type: AUTH_ERROR });
      clearToken();
      return;
    }
    // Otherwise, avoid flipping auth state; just stop loading.
    dispatch({ type: AUTH_END });
    // toast.error(err?.response?.data?.message ?? "Error Loading User Info")
  }
};

export const updateProfile = async (value) => async (dispatch) => {
  try {
    dispatch({ type: AUTH_START });
    const res = await updateProfileService(value);
    dispatch({ type: UPDATE_USER_PROFILE, payload: res?.data ?? res });
    toast.success(res?.message);
  } catch (err) {
    dispatch({ type: AUTH_ERROR });
    toast.error(
      err?.response?.data?.message ??
      "There seems to be a problem updating profile",
    );
  }
};

export const passwordReset = async (values) => async (dispatch) => {
  try {
    dispatch({ type: AUTH_START });
    const res = await resetPassword(values);
    dispatch({ type: RESET_PASSWORD });
    toast.success(res?.message);
    window.open("/login", "_self");
    return res?.data;
  } catch (err) {
    dispatch({ type: AUTH_ERROR });
    toast.error(err?.response?.data?.message ?? "Password reset failed");
  }
};

export const forgotUserPassword = async (values) => async (dispatch) => {
  try {
    dispatch({ type: AUTH_START });
    const res = await forgotPassword(values);
    dispatch({ type: FORGOT_PASSWORD });
    toast.success(res?.message);
    window.open("/reset-password", "_self");
    return res?.data;
  } catch (err) {
    dispatch({ type: AUTH_ERROR });
    toast.error(err?.response?.data?.message ?? "Error");
  }
};

export const verifyAcct = async (values) => async (dispatch) => {
  try {
    dispatch({ type: VERIFY_ACCOUNT_START });
    const res = await verifyAccount(values);
    dispatch({ type: VERIFY_ACCOUNT_SUCCESS });
    toast.success(res?.message);
    window.open("/login", "_self");
  } catch (err) {
    dispatch({ type: VERIFY_ACCOUNT_ERROR });
    toast.error(err?.response?.data?.message ?? "Error");
  }
};

export const logOut = () => (dispatch) => {
  dispatch({ type: LOG_OUT });
  clearToken();
  window.open("/", "_self");
};
